import Vue from 'vue'
import {helpers} from "../../helpers";

export default {
    store: {
        namespaced: true,
        state: {
            endpoint: 'logs',
            logs: [],
            log: {},
            logs_amount: 0
        },
        actions: {
            //получение логов
            getLogs({ rootState }, options) {
                let filter = []
                if (typeof options.module_id != 'undefined')   filter.push(["module_id",   "=", options.module_id]);
                if (typeof options.entity_id != 'undefined')   filter.push(["entity_id",   "=", options.entity_id]);
                if (typeof options.entity_type != 'undefined') filter.push(["entity_type", "=", options.entity_type]);
                let data = {
                    order_by:   'created_at',
                    order_type: 'desc',
                    filter: {model: [filter], relation: []}
                };

                return helpers.http.get({context: this, rootState}, '/log', {params: data});
            },

            //получение списка логов
            getLog({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/log/' + data.id, data).then(r => {
                    Vue.set(state, 'log', r);
                    return r;
                });
            },

            //получение списка логов с постраничной навигацией
            getAllLogs({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/log', {params: data}).then(r => {
                    Vue.set(state, 'logs', r.data);
                    Vue.set(state, 'logs_amount', r.total);
                    return r;
                });
            },

            //удаление записи лога
            removeLog({ state, rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/log/' + id).then(r => {
                    Vue.set(state, 'log', r);
                    return r;
                });
            },

            //удаление записи лога по фильтру по датам
            removeLogByDate({ rootState }, data) {
                data = {from: data.from, to: data.to};
                return helpers.http.delete({context: this, rootState}, '/log/delete/date', {params: data});
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/logs/store.js